import Maze from "./Maze.js";
import MazeConst from "./MazeConst.js";

export default class MazeRenderDebug {
	constructor(mazeModel, target,callback) {
		this.mazeModel = mazeModel;
		this.maze = this.mazeModel.maze;
		this.rows = this.mazeModel.rows;
		this.cols = this.mazeModel.cols;
		this.target = target;
		this.callback = callback;
	}

	init() {
		this.display();
	}

	destroy() {
		this.target.html("");
	}

	display() {
		for (let row = 0; row < this.rows; row++) {
			let jrow = jQuery("#template-maze-row").clone();
			jrow.attr("id", "mazrow" + MazeRenderDebug.ENUM++);
			this.target.append(jrow);
			for (let col = 0; col < this.cols; col++) {
				let jcel = jQuery("#template-maze-cell").clone();
				jcel.attr("id", "mazcel" + MazeRenderDebug.ENUM++);
				jrow.append(jcel);
				let cell = this.maze[row][col];
				cell.mc = jcel;
				jQuery(".js-wall", jcel).hide();
				jQuery(".js-start", jcel).hide();
				jQuery(".js-end", jcel).hide();
				if (cell.isWall()) {
					jQuery(".js-wall", jcel).show();
					jcel.addClass("is-wall");
				} else {
					//jQuery(".js-label", jcel).text(cell.distance);
					jQuery(".js-label", jcel).text(cell.pathIndex === MazeConst.INFINITE_DISTANCE ? "" : cell.pathIndex);
				}
				if (cell.start) {
					jQuery(".js-start", jcel).show();
					jcel.addClass("is-start");
				}
				if (cell.end) {
					jQuery(".js-end", jcel).show();
					jcel.addClass("is-end");
				}
				if (cell.deadEnd) {
					jQuery(".js-dead-end", jcel).show();
					let n = this.mazeModel.getNearbyCell(cell, Maze.DIR_N);
					let e = this.mazeModel.getNearbyCell(cell, Maze.DIR_E);
					let s = this.mazeModel.getNearbyCell(cell, Maze.DIR_S);
					let w = this.mazeModel.getNearbyCell(cell, Maze.DIR_W);
					if (!n.isWall()) {
						jQuery(".js-spikes", jcel).addClass("spikes-s");
					}
					if (!e.isWall()) {
						jQuery(".js-spikes", jcel).addClass("spikes-w");
					}
					if (!s.isWall()) {
						jQuery(".js-spikes", jcel).addClass("spikes-n");
					}
					if (!w.isWall()) {
						jQuery(".js-spikes", jcel).addClass("spikes-e");
					}
					
					

				}

				//console.log(cell)
				//if (cell.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (cell.isRoom()) {
					let room = this.mazeModel.getRoomById(cell.room)
					if (room) {
						if (room.isSecret()) {
							jcel.addClass("is-secret-room");
						} else {
							if (room.type === MazeConst.ROOM_TYPE_HALLWAY) {
								jcel.addClass("is-hallway");
							} else {
								jcel.addClass("is-room");
							}
						}
						if ((cell.rowRoom === Math.floor(room.h / 2)) && (cell.colRoom === Math.floor(room.w / 2))) {
							jQuery(".js-id-room", jcel).show()
							if (room.isSecret()){
								jQuery(".js-id-room", jcel).html("secret<br>room " + room.id);
							} else {
								if (room.type === MazeConst.ROOM_TYPE_HALLWAY) {
									jQuery(".js-id-room", jcel).html("hall " + room.id);
								} else {
									jQuery(".js-id-room", jcel).html("room " + room.id);
								}
							}
							jcel.css("z-index", 100);
							let w = jcel.width();
							let l = jQuery(".js-id-room", jcel).width();
							jQuery(".js-id-room", jcel).css("left", Math.floor((w - l) / 2));
							let h = jcel.height();
							let a = jQuery(".js-id-room", jcel).height();
							jQuery(".js-id-room", jcel).css("top", Math.floor((h - a) / 2));
						}
					}
				}

				if (cell.isRoomExit()) {
					//let room = this.getRoomById(cell.room)
					let exits = cell.roomExits;
					let lSecret = false;
					for (let x = 0; x < exits.length; x++) {
						let room = exits[x];
						/*console.log(exit)
						let room = this.getRoomById(exit.room);*/

						if (room.isSecret()) {
							lSecret = true;
							break;
						}
					}
					if (lSecret) {
						jQuery(".js-fake-wall", cell.mc).show()
						cell.mc.css("opacity", 0.7)
					} else {
						this.showDoor(cell, "door")
					}
				}
			}
		}
	}

	showDoor(cell, prefix) {
		let jcel = cell.mc;
		let n = this.mazeModel.getNearbyCell(cell, Maze.DIR_N);
		let e = this.mazeModel.getNearbyCell(cell, Maze.DIR_E);
		let s = this.mazeModel.getNearbyCell(cell, Maze.DIR_S);
		let w = this.mazeModel.getNearbyCell(cell, Maze.DIR_W);
		if (n) {
			if (n.isRoom()) {
				jQuery(".js-" + prefix, jcel).show()
				jQuery(".js-" + prefix, jcel).addClass(prefix + "-h");
			}
		}
		if (s) {
			if (s.isRoom()) {
				jQuery(".js-" + prefix, jcel).show()
				jQuery(".js-" + prefix, jcel).addClass(prefix + "-h");
			}
		}
		if (e) {
			if (e.isRoom()) {
				jQuery(".js-" + prefix, jcel).show()
				jQuery(".js-" + prefix, jcel).addClass(prefix + "-v");
			}
		}
		if (w) {
			if (w.isRoom()) {
				jQuery(".js-" + prefix, jcel).show()
				jQuery(".js-" + prefix, jcel).addClass(prefix + "-v");
			}
		}

	}

	showSolution(animated = true) {
		let path = this.mazeModel.solution;
		if (animated) {
			this.indexPath = -1;
			this.showNextStep(path);
		} else {
			for (let x = 0; x < path.length; x++) {
				let cell = path[x];
				jQuery(".js-path", cell.mc).show();
			}
		}
	}

	showNextStep(path) {
		this.indexPath++;
		if (this.indexPath < path.length) {
			let cell = path[this.indexPath];
			jQuery(".js-path", cell.mc).show();
			setTimeout(this.showNextStep.bind(this, path), 30);

			if (cell.isRoomExit()) {
				jQuery(".js-door", cell.mc).hide();
				this.showDoor(cell, "door-opened")
			}

		} else {
			this.dispatch({ type: MazeRenderDebug.EVENT_MAZE_TRAVERSED_OK });
		}
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

}

MazeRenderDebug.EVENT_MAZE_TRAVERSED_OK = "eventMazeTraversedOk";

MazeRenderDebug.ENUM = 0;
